import React from 'react';
import { Helmet } from 'react-helmet-async';
import { URLS } from '@shared/utils/urls';

/**
 * Loads the style applicator unless retry SSR already executed an inline copy.
 */
export const StyleApplicatorScript: React.FC = () => {
  if (typeof window !== 'undefined' && window.__SSR_STYLE_APPLICATOR_INLINED__) {
    return null;
  }

  return (
    <Helmet>
      <script src={URLS.styleApplicatorLib} />
    </Helmet>
  );
};
